import { render, staticRenderFns } from "./industrialSystem.vue?vue&type=template&id=c3bbb72e&scoped=true&"
import script from "./industrialSystem.vue?vue&type=script&lang=js&"
export * from "./industrialSystem.vue?vue&type=script&lang=js&"
import style0 from "./industrialSystem.vue?vue&type=style&index=0&id=c3bbb72e&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bbb72e",
  null
  
)

export default component.exports